module.exports = __webpack_public_path__ + "static/media/mSlider2.876f84a9.png";